module.exports = __webpack_public_path__ + "fonts/2d2ae25.woff";